import {
    GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS, GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS, GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE,
    ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS, ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS, ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE,
    EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS, EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS, EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    paymentInvoiceDeduction: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const payment_invoice_deduction_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS:
            return { ...state, paymentInvoiceDeduction: action.paymentInvoiceDeduction, loading: false };
        case GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS:
            return { ...state, loading: true };
        case ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS:
            return { ...state, paymentInvoiceDeduction: [...state.paymentInvoiceDeduction, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS:
            return {
                ...state,
                paymentInvoiceDeduction: state.paymentInvoiceDeduction.map((paymentInvoiceDeduction) =>
                paymentInvoiceDeduction._id === action.payload._id ? action.payload : paymentInvoiceDeduction
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default payment_invoice_deduction_reducer;